<template>
	<section class="search-area">
		<input v-model="form.text" type="text" placeholder="Digite aqui o seu termo de busca..." @keyup.enter="buscar" autofocus />

		<div class="vertical-separator">
			<div class="line"></div>
			<span>buscar por</span>
		</div>

		<div class="custom-select" @click="(evt) => { evt.target.closest('.custom-select').querySelector('.options').classList.toggle('show') }">
			<div class="placeholder">{{ formType }}</div>
			<div class="arrow">
				<span class="fa fa-angle-down"></span>
			</div>

			<div class="options">
				<div class="option" value="objeto" @click="selectItem">objeto</div>
				<div class="option" value="colecao" @click="selectItem">coleção</div>
			</div>
		</div>

		<button type="button" @click="buscar"><i class="fas fa-search"></i></button>
	</section>
</template>

<script>
import EventBus from '@/components/event-bus'
export default {
	name: 'SearchArea',
	data () {
		return {
			form: {
				text: '',
				type: this.$route.query.buscarPor || 'objeto'
			},
			tipos: []
		}
	},
	computed: {
		formType () {
			const el = document.querySelector(`.custom-select .option[value=${this.form.type}]`)
			return el ? el.innerHTML : 'objeto'
		}
	},
	methods: {
		buscar () {
			if (this.form.type === 'objeto') {
				this.$router.push({ name: 'resultadoObjeto', query: { texto: this.form.text, buscarPor: 'objeto' } })
				this.form.text = ''
			} else {
				this.$router.push({ name: 'resultadoColecao', query: { texto: this.form.text, buscarPor: 'colecao' } })
				this.form.text = ''
			}
		},
		selectItem (evt) {
			this.form.type = evt.target.getAttribute('value')
		}
	},
	beforeRouteEnter (to, from, next) {
		next(vm => (vm.path = from.path))
	},
	created () {
		EventBus.$on('buscarPor', (data) => {
			if (data) {
				this.form.type = data
			}
		})
		if (this.$route.query.texto) this.form.text = this.$route.query.texto
		if (this.$route.query.objeto) this.form.type = 'objeto'
	}
}
</script>

<style lang="scss" scoped>
.search-area {
	display: flex;
	min-width: 720px;
	height: 42px;
	font-size: .8em;
	font-family: 'Roboto Condensed', 'Roboto', sans-serif;
	color: #00659D;

	@media (max-width: 760px) {
		min-width: 100%;
		width: 100%;
	}

	input {
		height: 100%;
		width: 100%;
		outline: none;
		border: none;
		padding-left: 16px;
		font-size: 1em;
		color: $main-color;
		border-top-left-radius: 5px;
		border-bottom-left-radius: 5px;

		&::placeholder {
			opacity: 1;
			color: #00659D;
		}
	}

	.vertical-separator {
		height: 100%;
		width: 120px;
		background: #fff;
		display: flex;
		align-items: center;
		justify-content: center;
		color: #00659D;

		.line {
			height: 60%;
			width: 1px;
			background: #ccc;
			margin-right: 10px;
		}
	}

	.custom-select {
		position: relative;
		display: flex;
		align-items: center;
		flex-shrink: 0;
		width: 71px;
		background-color: #FFF;
		user-select: none;
		cursor: pointer;

		select {
			position: absolute;
			z-index: -1;
			opacity: 0;
		}

		.arrow {
			display: flex;
			align-items: center;
			padding: 0 10px;
			font-size: 18px;
		}

		.options {
			display: block;
			position: absolute;
			top: 42px;
			right: 0;
			background-color: #FFF;
			transform: scaleY(0);
			transform-origin: top;
			transition: .333s;

			&.show {
				transform: scaleY(1);
			}

			.option {
				width: 145px;
				padding: 5px 10px;
				text-align: center;
				transition: .266s;

				&:hover {
					background-color: #0169AB;
					color: #FFF;
				}
			}
		}
	}

	button {
		background-color: #00659D;
		color: #fff;
		border: none;
		height: 100%;
		outline: none;
		cursor: pointer;
		font-size: .9em;
		border-top-right-radius: 5px;
		border-bottom-right-radius: 5px;
		padding: 0 18px;

		i {
			font-size: 1.4em;
		}
	}
}
</style>
